import { fetchConToken } from "../helpers/fetch"
import { armarParametrosAuditoriaFacturas, armarParametrosCotizaciones } from "../helpers/parametros"

const ComprasServices = {
    traerEstadosSolicitud : () =>{
        return fetchConToken(`Cotizaciones/TraerEstadosCotizaciones`)
    },
    traerSolicitudesCotizaciones : (idAfiliado,idSolicitud, fechaInicio, fechaFin, idTipoSolicitud) =>{
        return fetchConToken(`Cotizaciones/TraerSolicitudesCotizacion?${armarParametrosCotizaciones(
            null,idAfiliado,idSolicitud, fechaInicio, fechaFin, idTipoSolicitud)}`)
    },
    BuscadorOferente : (parametros) =>{
        return fetchConToken(`Cotizaciones/TraerOferentesPorNombreoCUIT/${parametros}`)
    },

    consultarOferentesAbm : () => {
        return fetchConToken(`Compras/Oferentes`)
    },
    TraerSolicitudTerminada: (idSolicitud) =>{
        return fetchConToken(`Cotizaciones/BuscarSolicitudTerminada/${idSolicitud}`)
    },
    //PROVEEDORES//
    BuscadorProveedores : (parametros) => {
        return fetchConToken(`Compras/Proveedores/ConsultarProveedoresPorParametros/${parametros}`)
    },

    CrearProveedor : (data) => {
        return fetchConToken(`Compras/Proveedores`, data, 'POST')
    },

    ModificarProveedor : (idProveedor,data) => {
        return fetchConToken(`Compras/Proveedores/${idProveedor}`, data, 'PUT')
    },

    EliminarProveedor : (idProveedor) => {
        return fetchConToken(`Compras/Proveedores/${idProveedor}`, {}, 'DELETE')
    },

    NuevaCotizacion : (data) => {
        return fetchConToken(`Cotizaciones`, data, "POST");
    },
    TraerCotizaciones : (idEstado,idAfiliado,idSolicitud, fechaInicio, fechaFin, idTipoSolicitud) =>{
        return fetchConToken(`Cotizaciones/TraerCotizaciones?${armarParametrosCotizaciones(
            idEstado,idAfiliado,idSolicitud, fechaInicio, fechaFin , idTipoSolicitud)}`);
    },
    EditarDetalleCotizaciones : (data) => {
        return fetchConToken(`Cotizaciones/EditarDatosDetalleCotizacion`,data, "PUT");
    },
    EnviarCotizacion : (data) => {
        return fetchConToken(`Cotizaciones/EnviarCotizacion`,data, "POST");
    },
    AceptarCotizacion : (data) =>{
        return fetchConToken(`Cotizaciones/AceptarCotizacion`, data, "POST");
    },
    getContadoresCotizaciones : (idAfiliado,idSolicitud, fechaInicio, fechaFin, idTipoSolicitud) => {
        return fetchConToken(`Cotizaciones/TraerContadoresEstadosCotizaciones?${armarParametrosCotizaciones(
            null,idAfiliado,idSolicitud, fechaInicio, fechaFin, idTipoSolicitud)}`);
    },
    cambiarEstadoCotizacion : (idSolicitud) =>{
        return fetchConToken(`Cotizaciones/CambiarEstadoCotizacion/${idSolicitud}`, {},"POST");
    },
    agregarOferenteCotizacionCargada : (data) =>{
        return fetchConToken(`Cotizaciones/CargarOferenteEnCotizacion`,data,'POST')
    },
    //MATERIALES
    EliminarMaterialCotizacion : (idDetalleCotizacion) =>{
        return fetchConToken(`Cotizaciones/EliminarMaterialCotizacion/${idDetalleCotizacion}`, {},'DELETE');
    },
    //DOCUMENTACION
    TraerDocumentacionPorId : (idTipoDocu) =>{
        return fetchConToken(`CotizacionesDocumentacion/${idTipoDocu}`);
    },
    DeleteDocumentacion : (idCotizacionDocumentacion) =>{
        return fetchConToken(`CotizacionesDocumentacion/${idCotizacionDocumentacion}`, {}, "DELETE");
    },
    TraerTipoDocumentacion: ()=>{
        return fetchConToken(`CotizacionesDocumentacion/TraerTipoDocuCompras`);
    },
    //TRACKING
    TraerTrackingSolicitud : (idSolicitud) =>{
        return fetchConToken(`TrackingCotizaciones/traerPorSolicitud/${idSolicitud}`);
    },
    //EMAIL
    EnviarEmailAceptacionCotizacion : (idSolicitud, idOferente) =>{
        return fetchConToken(`Cotizaciones/enviarPDFAceptacionCotizacion/${idSolicitud}/${idOferente}`);
    },
    EnviarEmailPedidoCotizacion : (idSolicitud, idOferente) =>{
        return fetchConToken(`Cotizaciones/enviarPDFPedidoCotizacion/${idSolicitud}/${idOferente}`);
    },
    EnviarEmailIncorporacionOferente : (idSolicitud, idOferente) =>{
        return fetchConToken(`Cotizaciones/enviarMailIncorporacionOferente/${idSolicitud}/${idOferente}`);
    },
    //AUDITORIA FACTURAS 
    GetComprobantes : (idAfiliado, idSolicitudAuditoria, fechaInicio, fechaFin) =>{
        return fetchConToken(`AuditoriaFacturacionCompras/TraerComprobantes?${armarParametrosAuditoriaFacturas(
            idAfiliado, idSolicitudAuditoria, fechaInicio, fechaFin)}`);
    },
    GetComprobantesPorEstado : (idAfiliado, idSolicitudAuditoria, idEstado, fechaInicio, fechaFin) =>{
        return fetchConToken(`AuditoriaFacturacionCompras/TraerComprobantesPorEstado?${armarParametrosCotizaciones(
            idEstado, idAfiliado, idSolicitudAuditoria, fechaInicio, fechaFin)}`);
    },
    GetEstados : () =>{
        return fetchConToken(`AuditoriaFacturacionCompras/TraerEstados`);
    },
    getContadoresAuditoria : (idAfiliado,idSolicitud, fechaInicio, fechaFin) => {
        return fetchConToken(`AuditoriaFacturacionCompras/TraerContadoresEstadosAuditoria?${armarParametrosCotizaciones(
            null,idAfiliado,idSolicitud, fechaInicio, fechaFin)}`);
    },
    guardarDetalleFacturacionSinCotizacion: (data) =>{
        return fetchConToken(`AuditoriaFacturacionCompras/GuardarDetalleFacturacionSC`,data,"POST");
    },
    guardarDetalleFacturacionConCotizacion : (data) =>{
        return fetchConToken(`AuditoriaFacturacionCompras/GuardarDetalleFacturacionCC`,data,"POST");
    },
    GetMaterialesTramite : (idTramiteCompra) =>{
        return fetchConToken(`AuditoriaFacturacionCompras/TraerMaterialesTramiteCompra/${idTramiteCompra}`);
    },
    aceptarRechazarTramites : (idTramiteCompra, data) =>{
        return fetchConToken(`AuditoriaFacturacionCompras/AceptarRechazarTramite/${idTramiteCompra}`,data,"PUT");
    },
    GetMaterialesCotizacion : (data) =>{
        return fetchConToken(`AuditoriaFacturacionCompras/TraerMaterialesCotizacion`, data, "POST");
    },
    TraerTrackingFacturacion : (idTramiteCompra) =>{
        return fetchConToken(`AuditoriaFacturacionCompras/traerPorIdTramite/${idTramiteCompra}`);
    },
    NuevaCotizacionExpress : (data) => {
        return fetchConToken(`Cotizaciones/NuevaCotizacionExpress`, data, "POST");
    },
    EnviarAPagadas: (idTramiteCompra, data) =>{
        return fetchConToken(`AuditoriaFacturacionCompras/EnviarAPagadas/${idTramiteCompra}`, data, "PUT")
    },
    AnularSolicitud: (data) =>{
        return fetchConToken(`Cotizaciones/bajaSolicitud`,data, "PUT");
    }
}
export {ComprasServices as default}